import { computed as e, createBlock as t, createTextVNode as n, defineComponent as r, normalizeClass as i, normalizeStyle as a, openBlock as o, renderSlot as s, resolveDynamicComponent as c, toDisplayString as l, unref as u, withCtx as d } from "vue";
import { getHttpMethodInfo as f } from "@scalar/helpers/http/http-info";
import { isHttpMethod as p } from "@scalar/helpers/http/is-http-method";
//#region src/code-example/components/HttpMethod.vue?vue&type=script&setup=true&lang.ts
var m = /*@__PURE__*/ r({
	__name: "HttpMethod",
	props: {
		as: {},
		property: {},
		short: { type: Boolean },
		method: {}
	},
	setup(r) {
		let m = r, h = e(() => f(String(m.method || ""))), g = e(() => {
			if (typeof m.method != "string" || !m.method.trim()) return "get";
			let e = m.method.trim();
			return p(e.toLowerCase()) ? e.toLowerCase() : e;
		});
		return (e, f) => (o(), t(c(r.as ?? "span"), {
			class: i({ uppercase: u(p)(g.value) }),
			style: a({ [r.property || "color"]: h.value.colorVar })
		}, {
			default: d(() => [s(e.$slots, "default"), n(" " + l(r.short ? h.value.short : g.value), 1)]),
			_: 3
		}, 8, ["class", "style"]));
	}
});
//#endregion
export { m as default };

//# sourceMappingURL=HttpMethod.vue_vue_type_script_setup_true_lang.js.map